import { useState } from "react";
import { Navbar } from "react-bulma-components";
import { Link, useLocation } from "wouter";
import { useT } from "i18n/I18nProvider";

import styles from "./Footer.module.scss";

export const Footer = () => {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [location] = useLocation();
  const t = useT();
  const menu = [
    {
      name: t("footer.home"),
      path: "/",
    },
    {
      name: t("footer.rules"),
      path: "/rules",
    },
  ];
  return (
    <Navbar className={styles.footer} active={isMenuActive} color="dark">
      <Navbar.Brand>
        <Navbar.Burger onClick={() => setIsMenuActive(!isMenuActive)} />
      </Navbar.Brand>
      <Navbar.Menu>
        <Navbar.Container align="left">
          {menu.map(({ name, path }) => {
            return (
              <Navbar.Item
                key={path}
                active={location === path}
                href={path}
                renderAs={Link}
              >
                {name}
              </Navbar.Item>
            );
          })}
        </Navbar.Container>
      </Navbar.Menu>
    </Navbar>
  );
};
